module.exports = __webpack_public_path__ + "img/1538355115.b9f15572.jpg";